"use client";

import { TSubtitle } from "@shared/cms";
import { imageFallback } from "@shared/utils";
import { cn } from "@ubud-ui/react-ui-kit";
import Image from "next/image";

type SubtitleProp = TSubtitle & {
  containerClass?: string;
  textClass?: string;
};

export function Subtitle({ containerClass, textClass, title, icon }: SubtitleProp) {
  return (
    <div className={cn("flex items-center space-x-2", containerClass)}>
      {icon && (
        <Image
          src={icon.url}
          width={icon.width || 24}
          height={icon.height || 24}
          alt={icon.alternativeText || icon.name || ""}
          className="size-5 lg:size-6 text-primary min-w-5 lg:min-w-6"
          onError={imageFallback()}
        />
      )}
      <div className={cn("sm:text-base font-medium text-gray-700", textClass)}>{title}</div>
    </div>
  );
}
